import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { PaginatedResponse, Gsis } from "@shared/models";
import { Observable } from "rxjs";
import { ToHttpHeadersService } from "../utils";
import { LABELS } from "@shared/constants";
import { ListActions } from "@shared/enums";

@Injectable({
	providedIn: 'root'
})
export class GsisService {

	readonly url = `/api/v1/payroll/gsis`;
	readonly http = inject(HttpClient);
	readonly toHttpHeaders = inject(ToHttpHeadersService);
	readonly label = LABELS.GSIS_CONFIGURATION;

	list(params?: Partial<Gsis>): Observable<PaginatedResponse<Gsis>> {
		return this.http.get<PaginatedResponse<Gsis>>(`${this.url}`, { params });
	}

	post(data: Gsis): Observable<Gsis> {
		return this.http.post<Gsis>(this.url, data, this.toHttpHeaders.generateHeaders(ListActions.CREATE, this.label));
	}

	put(data: Gsis): Observable<Gsis> {
		return this.http.put<Gsis>(this.url, data, this.toHttpHeaders.generateHeaders(ListActions.UPDATE, this.label));
	}

	delete(id: number): Observable<Gsis> {
		return this.http.delete<Gsis>(`${this.url}/${id}`, this.toHttpHeaders.generateHeaders(ListActions.DELETE, this.label));
	}
}